import React, { FC } from 'react';
import ModalLayout from '../../../../components/ModalLayout';
import ModalChangeTaskBody from './ModalChangeTaskBody';
import ModalChangeTaskFooter from './ModalChangeTaskFooter';
import ModalChangeTaskHeader from './ModalChangeTaskHeader';
import ModalChangeTaskRepeat from './ModalChangeTaskRepeat';

interface IModalChangeTask {
    flag: boolean,
    setModalFlag: any,
    currentTask?: any,
}

const ModalChangeTask: FC<IModalChangeTask> = ({ currentTask, flag, setModalFlag }) => {
    return (
        <ModalLayout flag={flag} onClose={setModalFlag}>
            <ModalChangeTaskHeader currentTask={currentTask} />
            <ModalChangeTaskBody currentTask={currentTask} />
            <ModalChangeTaskRepeat currentTask={currentTask} />
            <ModalChangeTaskFooter currentTask={currentTask} onClose={setModalFlag} />
        </ModalLayout>
    )
}

export default ModalChangeTask;